<template>
  <div 
    class="modal-container position-fixed top-0 start-0 flex-center"
  >
    <div class="modal-wrapper">
      <h4 class="title-wrapper text-center">
        {{ title }}
      </h4>
      <div v-if="message || subMessage" class="message-wrapper text-center">
        <p v-if="message" class="message">{{ message }}</p>
        <span v-if="subMessage" class="sub-message">{{ subMessage }}</span>
      </div>
      <slot />
      <div class="mx-auto flex-center">
        <Button
          class="cancel-btn action-btn text-capitalize"
          :variant="cancelVariantOrDefault"
          size="sm"
          testId="close-dialog"
          :loading="cancelLoadingOrDefault"
          :disabled="confirmLoadingOrDefault || cancelDisabled"
          @click="emit('cancelModal')"
          >{{ cancelText ?? 'cancel' }}</Button
        >
        <Button
          class="action-btn text-capitalize"
          size="sm"
          testId="confirm-dialog-action"
          @click="emit('confirm')"
          :loading="confirmLoadingOrDefault"
          :disabled="cancelLoadingOrDefault || confirmDisabled"
          :variant="confirmVariantOrDefault"
          >{{ confirmText ?? 'yes' }}</Button
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Button } from "@/components/global";
import { ButtonVariant } from './Button.vue';

const props = defineProps<{
  title: string;
  message?: string;
  subMessage?: string;
  loading?: boolean;
  confirmLoading?: boolean;
  cancelLoading?: boolean;
  confirmDisabled?: boolean;
  cancelDisabled?: boolean;
  confirmText?: string;
  cancelText?: string;
  confirmButtonVariant?: ButtonVariant;
  cancelButtonVariant?: ButtonVariant;
}>();

const emit = defineEmits(['cancelModal', 'confirm']);

const cancelVariantOrDefault = computed(() => props.cancelButtonVariant || 'outline');
const confirmVariantOrDefault = computed(() => props.confirmButtonVariant || 'default');
const confirmLoadingOrDefault = computed(() => props.confirmLoading ?? props.loading ?? false);
const cancelLoadingOrDefault = computed(() => props.cancelLoading ?? false);
</script>

<style scoped>
.modal-container {
  z-index: 1050;
  padding: 1rem;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-wrapper {
  padding: 1.5rem;
  width: 100%;
  height: auto;
  max-width: 28rem;
  background-color: white;
  border-radius: 10px;
}

.title-wrapper {
  margin: 0;
  font-weight: 500;
  font-size: 1.375rem;
  color: #191c1c;
  text-transform: capitalize;
}

.message-wrapper {
  margin: 1rem auto;
  max-width: 24rem;
}

.message-wrapper .message {
  color: #8e9191;
  font-size: 0.8125rem;
  font-weight: 400;
}

.message-wrapper .sub-message {
  color: var(--ch-dark-grey);
  font-size: var(--font-sm);
  font-weight: 500;
}

.action-btn {
  max-width: 10rem;
  max-height: 2.25rem;
  border-radius: 0.5rem;
}

.cancel-btn {
  margin-right: 0.75rem;
  color: var(--ch-blue-100);
}
</style>
